import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import AprilAtonementBanner from '~/main/components/AprilAtonementBanner';
import { fetchNodeIfNeeded } from '~/nodes/actions';
import Prizes from '~/main/components/Prizes';

const AprilAtonement = (props) => {
	const { dispatch, nodes } = props;
	useEffect( () => {
		dispatch(fetchNodeIfNeeded('april-atonement'))
	}, [])
	return (
		<div className="april-atonement">
			<AprilAtonementBanner />
			{/* <div style={{ fontSize: '10vw', fontWeight: '900', fontFamily: "Titillium Web", color: 'rgb(255, 255, 255)',
  textShadow: 'rgb(2, 0, 2) -4px 5px 0px',
textTransform: 'uppercase', textAlign: 'center', lineHeight: '85%' }} className="april-atonement-text">
				<span style={{fontSize: '50%'}}>4ZZZ</span><br />
				<span>April Atonement</span>
			</div> */}

			{ nodes['april-atonement'] && nodes['april-atonement'].body && 
        <div className="margin">
					<h2 style={{textAlign: 'center'}}>Atone this April and give yourself over to the station you love.</h2>
					<div dangerouslySetInnerHTML={{ __html: nodes['april-atonement'].body[0].value}}></div>
				</div>
			}
			{/* <div style={{position: 'relative', height: '40vw'}}>

			<div style={{ backgroundImage: 'url(assets/aa-23-witch-2.png)', width: '28vw', height: '28vw', backgroundSize: 'contain', backgroundRepeat: 'no-repeat',  position: 'absolute', top: '4vw', left: '5vw', animation: 'broomstick 3s ease-in-out infinite'  }}></div>

			<div style={{ backgroundImage: 'url(assets/aa-23-witch-3.png)', width: '28vw', height: '28vw', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', position: 'absolute', top: '4vw', left: '35vw', animation: 'broomstick 7s ease-in-out infinite'  }}></div>

			<div style={{ backgroundImage: 'url(assets/aa-23-witch-1.png)', width: '23vw', height: '22vw', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', position: 'absolute', top: '4vw', left: '75vw', animation: 'broomstick 5s ease-in-out infinite' }}></div>




			</div> */}
			<Prizes category="april-atonement" variant="list" />
		</div>
	)
}

AprilAtonement.fetchData = (store, route, match) => {
	return store.dispatch(fetchNodeIfNeeded('april-atonement'))
}

export default connect( state => ( { nodes: state.nodes } )) (AprilAtonement)